import { Card } from '@platform/components';
import { RepCard, RepProjectPanelProject } from '@platform/client/schemas';
import dataTestids from '../../constants/test-ids';
import { getHeaderContent, getButtonProps, getCardStatusBadge, getSubtext } from './utils';
import { useSearch } from 'wouter';
import { useEffect, useContext } from 'react';
import { IntroductionModalContext } from './Modals/IntroductionModal';
import { ROUTES } from '../../routes/consts';

export interface RepUserCardProps {
  cardData: RepCard;
  project?: RepProjectPanelProject;
}

export const RepUserCard = (props: RepUserCardProps) => {
  const { cardData, project } = {
    ...props,
  };

  const { openIntroductionModal } = useContext(IntroductionModalContext);

  // Open modal if introductionId is in the URL param
  const searchParams = useSearch();
  const urlSearchParams = new URLSearchParams(searchParams);
  const paramIntroId = parseInt(urlSearchParams.get('introductionId') ?? '');
  useEffect(() => {
    if (paramIntroId && paramIntroId === cardData.introduction.id) {
      openIntroductionModal({
        userType: 'organization',
        cardData: cardData,
        project: project,
      });
    }
  }, [paramIntroId, cardData, openIntroductionModal, project]);

  const { professional, avatar } = { ...cardData };

  const proName = professional.firstname + ' ' + professional.lastname;

  const headerContentProps = getHeaderContent({ cardData, userType: 'rep' });
  const subtext = getSubtext({ cardData, userType: 'rep' });
  const statusBadge = getCardStatusBadge(cardData.cardStatus);
  const buttonProps = getButtonProps({
    openIntroModal: () =>
      openIntroductionModal({
        userType: 'organization',
        cardData: cardData,
        project: project,
      }),
    cardData,
    userType: 'rep',
  });

  const headerContent = <div className='font-medium'>{headerContentProps.headerText}</div>;

  return (
    <Card
      headerContent={headerContent}
      headerColor={headerContentProps.headerColor}
      buttonText={buttonProps?.buttonText}
      buttonVariant={buttonProps?.buttonVariant}
      content={proName}
      contentTextHref={
        professional.id ? `platform${ROUTES.DIRECTORY}/professionals/${professional.id}` : undefined
      }
      avatarSize='md'
      avatarHref={avatar || ''}
      contentSubText={subtext}
      badges={[statusBadge]}
      variant='small'
      buttonOnClick={buttonProps?.buttonCta}
      userOrOrg='user'
      dataTestId={`${dataTestids.MY_PROJECTS.PROJECT_CARD.CONTAINER}-${project?.id ?? 'custom'}-${professional.id}`}
    />
  );
};
